// In-app feedback v1 — useSendFeedback.
// Mutation hook wrapping POST /v1/feedback. Mirrors useInitiateTransfer.ts.
//
// Deliberately NOT queued through the offline mutation queues
// (lib/serviceQueue.ts) — those queues are IndexedDB, and a feedback body may
// carry contact PII (an email address). FeedbackModal disables submit while
// offline instead (via useOnlineStatus) rather than risking PII sitting in
// local storage. Do not "fix" this into the queue.

import { apiFetch } from '@/lib/api';
import { FeedbackResponseSchema } from '@/lib/schemas';
import type { FeedbackRequest, FeedbackResponse } from '@/types/api';
import { useMutation, type UseMutationResult } from '@tanstack/react-query';

export function useSendFeedback(): UseMutationResult<FeedbackResponse, Error, FeedbackRequest> {
  return useMutation<FeedbackResponse, Error, FeedbackRequest>({
    mutationFn: (input) =>
      apiFetch<FeedbackResponse>('/v1/feedback', {
        method: 'POST',
        body: input,
        schema: FeedbackResponseSchema,
      }),
  });
}
